import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Link } from "@material-ui/icons";
import React from "react";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import { themeEnquiryService } from "../../../services";
import { TileProps } from "../../../services/core/types";
import { userRendererStyles } from "./useRendererStyles";

export const ListTile: React.FC<TileProps> = ({ tile, navigate }) => {
  const classes = userRendererStyles();

  return (
    <Grid item xs={12} md={6}>
      <Card className={classes.root}>
        <CardHeader
          action={
            <Tooltip title={`View list of ${tile.title}`}>
              <IconButton onClick={() => navigate && navigate(tile.filterUrl)}>
                <Link />
              </IconButton>
            </Tooltip>
          }
          title={
            <Typography variant="body1" className={classes.cardHeading}>
              {tile.title}
            </Typography>
          }
          className={classes.header}
        />
        <Divider />
        <CardContent>
          <Grid container>
            <Grid item xs={12}>
              <List>
                {tile.parsedData.map((data, index) => {
                  return (
                    <ListItem key={index}>
                      <ListItemIcon>
                        <Tooltip title="View list">
                          <IconButton
                            onClick={() =>
                              navigate &&
                              navigate(
                                `${tile.filterUrl}&DashboardParam=${data.key}`
                              )
                            }
                          >
                            <Avatar className={classes.countAvatar}>
                              {data.value}
                            </Avatar>
                          </IconButton>
                        </Tooltip>
                      </ListItemIcon>
                      <ListItemText
                        primary={getListText(tile.title, data.key)}
                        className={classes.listText}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

const getListText = (tileTitle: string, dataTitle: string) => {
  switch (tileTitle) {
    case "Top Themes Today":
    case "Top Themes Yesterday":
      return <ThemesListTileText title={dataTitle} />;
    default:
      return <Typography component="span">{dataTitle}</Typography>;
  }
};

const ThemesListTileText: React.FC<{ title: string }> = ({ title }) => {
  const [tileLookup] = useLookup(themeEnquiryService);
  const themeName = tileLookup.find((theme) => theme.id === parseInt(title));

  return (
    <Typography component="span">{themeName?.label ?? "No Theme"}</Typography>
  );
};
